import $ from 'jquery';
import * as TagManager from 'scripts/components/analytics/tagManagerApi';

const updateContactForm = (data) => {
  return $.ajax({
    url: `/api/aktivcontact/contactform/${data.eaTaskId}/additionalinfo`,
    type: 'PUT',
    data: {
      description: $('#aktivReceiptTextareaComment').val(),
      reason: $("input[name='aktivReceiptInputReason']:checked").val(),
    },
  });
};

const pushToTagManager = (metadata, reason) => {
  TagManager.push({
    'event': metadata.event,
    'inputReason': reason,
  });
};

export const init = (data) => {
  $('#aktivReceiptName').html(data.name);
  const receiptCard = $('#aktivReceiptCard');
  receiptCard.show();

  const $buttonsContainer = $('#aktivReceiptButtonsContainer');
  const $formContainer = $('#aktivReceiptFormContainer');

  const $sendButton = $('#aktivReceiptButtonSend');
  const $noSendButton = $('#aktivReceiptButtonNoSend');
  const $errorMsg = $('#aktivReceiptErrorMsg');
  const $successMsg = $('#aktivReceiptSuccessMsg');

  const buttonText = $sendButton.text();
  const buttonBusyText = $sendButton.attr('data-busy-text');

  $noSendButton.click(event => {
    event.preventDefault();
    $buttonsContainer.hide();
    $formContainer.hide();
  });
  receiptCard.on('submit', 'form', event => {
    event.preventDefault();
    $sendButton.attr('disabled', 'disabled');
    $sendButton.text(buttonBusyText);
    $errorMsg.hide();

    updateContactForm(data).then(() => {
      const reason = $("input[name='aktivReceiptInputReason']:checked").val();
      pushToTagManager(data.tagManagerMetaData, reason);

      $successMsg.show();
      $buttonsContainer.hide();
      $formContainer.hide();
    }, () => {
      $errorMsg.show();
    }).always(() => {
      $sendButton.removeAttr('disabled');
      $sendButton.text(buttonText);
    });
  });
};
